import React from "react";

// 🔷 Components Import
import Newhome from "./Newhome"; // Header + Banner

import Newhomefooter from "./Newhomefooter";
import Moredetailsfaq from "./Moredetailsfaq";

const Morefaqpage = () => {
  return (
    <>
    <div className="home-page-new">
      {/* 🔷 HEADER + HERO */}
      <Newhome />

      {/* 🔷 Screen Reader */}
    
      <Moredetailsfaq />
      <Newhomefooter />
      </div>
    </>
  );
};

export default Morefaqpage;